import { ReactComponent as WarningIcon } from '@assets/images/warningIcon.svg';
import './style.scss';

type ErrorSectionProps = {
  title: string;
};

const ErrorSection = ({ title }: ErrorSectionProps) => (
  <div data-testid="error-section" className="error-section">
    <WarningIcon />
    <p>{title}</p>
  </div>
);

export { ErrorSection };
